const deg2rad = deg => deg * (Math.PI / 180);
const MILES_IN_KM = 0.62137119;

export const distanceInMiles = (distance = 0) => distance * MILES_IN_KM;

const distanceBetweenLatLons = (lat1, lon1, lat2, lon2, usesMetricSystem) => {
  const R = 6371; // radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // distance in km

  if (usesMetricSystem) {
    return d;
  }

  return distanceInMiles(d);
};

// items is an array of [{ latitude, longitude }, obj] pairs
export const sortByDistance = (location, items) => {
  const distanceObjectPairs = items.map(item => [
    distanceBetweenLatLons(location.latitude, location.longitude, item[0].latitude, item[0].longitude),
    item[1],
  ]);

  distanceObjectPairs.sort((a, b) => a[0] - b[0]);

  return distanceObjectPairs.map(pair => pair[1]);
};
